import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgSelectModule } from '@ng-select/ng-select';
// Ag-Grid
import {
  GridOptions,
  GridApi,
  RowSelectionOptions,
} from 'ag-grid-community';
 import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
// models
import { PaymentHistoryColumnDef } from './columnDefs';
import { SharedService } from 'src/app/shared/services/shared.service';
import { PaymentHistory } from 'src/app/shared/models/accounting';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, NgSelectModule, CollapseModule, AgGridAngular]
})
export class PaymentComponent implements OnInit {
  subscriptions = new Subscription();
  accountForm!: FormGroup; // Add definite assignment assertion
  paymentForm!: FormGroup; // Add definite assignment assertion
  paymentHistoryData: PaymentHistory[] = [];
  
  // ag-grid properties Grid
  gridApi!: GridApi;
  columnDefs = PaymentHistoryColumnDef;
  defaultColDef: any; // Add type
  detailCellRendererParams: any;
  overlayLoadingTemplate: string | undefined; // Add type
  overlayNoRowsTemplate: string | undefined; // Add type
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,};
  components: any;

  payment_types: string[] = ['Visa', 'Mastercard', 'Bank Account'];
  lower_view: 'user' | 'payment' = 'payment';
  showCreditCard = true;
  theme = agGridDarkTheme;
  
  constructor(
    private formBuilder: FormBuilder,
    public sharedService: SharedService
  ) {
    this.paymentForm = this.formBuilder.group({
      payment_type: ['', Validators.required],
      card_number: ['', Validators.required],
      card_exp_date: ['', Validators.required],
      card_cvv: ['', Validators.required],
      card_name: ['', Validators.required],
      billing_address: ['', Validators.required],
      billing_address2: ['', Validators.required],
      billing_city: ['', Validators.required],
      billing_state: ['', Validators.required],
      billing_zip_code: ['', Validators.required],
      billing_email: ['', Validators.required],
      billing_phone: ['', Validators.required],
    });
    
    this.gridOptions = {
      rowHeight: 30,
      rowSelection: {
        mode: 'singleRow',
        enableSelectionWithoutKeys: false,
        checkboxes: false,
      } as RowSelectionOptions,
    };
  }
 
  onGridReady(params: any) {
    this.gridApi = params.api;
  }
  
  ngOnInit(): void {
    this.createPaymentHistory();
  }
  
  createPaymentHistory() {
    const paymentHistory = new PaymentHistory();
    paymentHistory.statement_date = '2023-10-01';
    paymentHistory.invoice_number = 'INV123456';
    paymentHistory.account_number = 'ACC7890';
    paymentHistory.contact = 'John Doe';
    paymentHistory.ffl = 'FFL123456';
    paymentHistory.company_name = 'Example Company';
    paymentHistory.address_street = '123 Main St';
    paymentHistory.address_city = 'Anytown';
    paymentHistory.address_state = 'CA';
    paymentHistory.address_zip_code = '12345';
    paymentHistory.subscription_type = 'Monthly';
    paymentHistory.subscription_amount = '100.00';
    this.paymentHistoryData.push(paymentHistory);
    this.paymentHistoryData = [...this.paymentHistoryData];
  }
  
  savePayment() {
    console.warn('Saving payment')
  }
  
}
